import React from 'react';
import { Container, Typography, Button, Grid } from '@material-ui/core';
import Slide from 'react-reveal/Slide'
import banner from '../../assets/oleh.png';
import './style.css'

const Banner = ({ refProduct, refHome }) => {
    function showProduct() {
        window.scrollTo({
          top: refProduct.current.offsetTop - 30,
          behavior: "smooth"
        })
      }

    return (
        <main className="content" ref={refHome}>
        <div className="banner" color="inherit">
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={6}>
                        <Slide left>
                            <Typography className="title" variant="h2">
                                Toko Oleh-Oleh <span className="caption">Khas Bangka Belitung</span>
                            </Typography>
                            <Button className="shopping-button" onClick={showProduct}>Beli Oleh-Oleh</Button>
                        </Slide>
                    </Grid>

                    <Grid className="brand" item sm={6}>
                        <Slide right>
                            <img src={banner} alt="banner"/>
                        </Slide>
                    </Grid>

                </Grid>
            </Container>
        </div>
        </main>
    )
}

export default Banner